import main from './related-page';
export default main;